import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

/**
 * Blocco riutilizzabile per feature riservate al piano Pro.
 * Puo' essere usato come contenuto a pagina intera o dentro un overlay
 * (es. sopra una card sfocata). Non ha bisogno di darkMode: la palette
 * "Sunset Calm" (peach chiaro) funziona bene su entrambi gli sfondi.
 */
export default function UpgradePrompt({
  title = "Funzionalità Pro",
  message = "Questa funzionalità è disponibile con il piano Pro.",
}) {
  return (
    <div className="flex items-center justify-center w-full h-full p-6">
      <div className="max-w-sm w-full rounded-2xl border-2 border-forfy-100 bg-forfy-50 p-6 text-center shadow-sm">
        <div className="mx-auto w-12 h-12 rounded-full bg-forfy-100 flex items-center justify-center">
          <Lock className="w-6 h-6 text-forfy-600" />
        </div>
        <h3 className="mt-3 text-base font-bold text-neutral-900">{title}</h3>
        <p className="mt-1.5 text-sm text-neutral-600">{message}</p>
        <Link
          to="/checkout"
          className="mt-4 inline-flex items-center justify-center px-4 py-2 rounded-lg bg-forfy-500 text-white text-sm font-medium hover:bg-forfy-600 transition-colors"
        >
          Passa a Pro
        </Link>
      </div>
    </div>
  );
}
